<template>
  <ui-input
    class="ui-phone-input--wrapper"
    @blur="onBlur"
    :label="label"
    :placeholder="placeholder"
    v-model="model"
    :errorMessages="errorsMsg"
  />
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { useI18n } from '@/composables';

const props = withDefaults(
  defineProps<{
    modelValue?: string;
    label?: string;
    placeholder?: string;
    labelHelp?: string;
    errorMessages?: string[];
  }>(),
  {
    modelValue: '',
    label: '',
    errorMessages: () => [],
  },
);

const emit = defineEmits<{
  'update:modelValue': [value: string];
  change: [value: string];
  blur: [value: string];
  valid: [value: boolean];
}>();

const { t } = useI18n();
const innerErrors = ref<string[]>([]);

const model = computed({
  get: () => props.modelValue,
  set: (value: string) => {
    emit('update:modelValue', value);
    emit('change', value);
  },
});

const errorsMsg = computed(() => [...innerErrors.value, ...props.errorMessages][0]);

const onBlur = () => {
  emit('blur', model.value);
  if (isValidPhoneNumber(model.value) || !model.value) {
    emit('valid', true);
    innerErrors.value = [];
  } else {
    emit('valid', false);
    innerErrors.value = [
      t('Phone number should contain country code with + and correct amount of digits, e.g. +1 541 754 3010'),
    ];
  }
};
</script>
